<template>
  <div>
    <b-modal :id="'modal-new-ref-' + prop.definition.name" ref="newRefModal" size="xl" @ok="refSaved" no-close-on-backdrop>
      <template #modal-title>
        <div>
          Create new Ref of type "{{prop.definition.name}}"
        </div>
        <div v-if="saveResult">
          <b-alert class="mt-1"  variant="danger" :show="!saveResult.success" >{{ saveResult.message }}</b-alert>
        </div>
      </template>
      <b-form>
        <b-container>
          <b-form-row v-for="(propChunk,index) in itemPropertiesChunks" :key="index" cols="2">
            <b-col v-for="prop in propChunk" v-bind:key="prop.definition.name">
              <b-form-group
                :id="prop.definition.name"
                :label="prop.definition.title  ? prop.definition.title : prop.definition.name"
                :label-for="prop.definition.name"
                :description="prop.definition.description ? prop.definition.description : 'No description'"
              >
                <Component :is="prop.component" v-bind="{ prop: prop }"/>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-container>
      </b-form>
    </b-modal>
    <div class="d-flex align-items-center">
      <v-select style="width: 100%" v-model="prop.selectedOption" :options="prop.options" />
      <b-button title="Add Item" @click="createNew" style="margin-left: 5px"><b-icon-plus></b-icon-plus></b-button>
    </div>
  </div>
</template>
<script>

// eslint-disable-next-line no-unused-vars
import TextInput from './TextInput'
// eslint-disable-next-line no-unused-vars
import EnumInput from './EnumInput'
import { BackendApiService } from '../../services/BackendApiService'
import _ from 'lodash'

export default {
  name: 'RefInput',
  components: {
    TextInput,
    EnumInput
  },
  props: {
    prop: {},
    schema: {}
  },
  data () {
    return {
      saveResult: null,
      itemProperties: [],
      itemPropertiesChunks: []
    }
  },
  methods: {
    createNew () {
      this.saveResult = null
      this.prepareItemProperties()
      this.$bvModal.show('modal-new-ref-' + this.prop.definition.name)
    },
    prepareItemProperties () {
      let newItemProperties = []
      let customerIdProp = {component: 'TextInput', definition: {name: 'customerId', title: 'Ref ID', description: 'The ref ID'}, value: null, options: [], readonly: false}
      let ownerProp = {component: 'TextInput', definition: {name: 'owner', title: 'Owner', description: 'The owner'}, value: null, options: [], readonly: true}
      let companyIdProp = {component: 'TextInput', definition: {name: 'companyId', title: 'Company ID', description: 'The company ID'}, value: null, options: [], readonly: false}
      newItemProperties.push(customerIdProp)
      newItemProperties.push(ownerProp)
      newItemProperties.push(companyIdProp)
      this.prop.refDef.itemProperties.forEach((propDef) => {
        let itemProp = this.createItemPropertyForPropDefinition(propDef)
        newItemProperties.push(itemProp)
      })
      this.itemProperties = newItemProperties
      this.itemPropertiesChunks = _.chunk(Object.values(this.itemProperties), 2)
    },

    createItemPropertyForPropDefinition (propDef) {
      let result = {component: 'TextInput', definition: propDef, value: null, options: []}
      if (propDef.enum) {
        let mappedOptions = propDef.validOptions.map((value) => [value, value])
        mappedOptions.forEach((key, value) => {
          result.options.push(key[0])
        })
        result.component = 'EnumInput'
      }
      return result
    },
    refSaved (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.saveChanges((response) => {
        if (response.success) {
          this.$bvModal.hide('modal-new-ref-' + this.prop.definition.name)
          this.$store.state.newRefId = response.savedItem.customerRefId
          this.$store.state.newRefFieldName = response.savedItem.fieldName
          this.$store.state.refUpdate++
        }
      })
    },
    saveChanges (callback) {
      this.saveResult = null
      let itemProps = Object.fromEntries(this.itemProperties.map((itemProp) => [itemProp.definition.name, itemProp.value]))
      let itemId = 'new'

      return BackendApiService.saveRef(this.schema.id, this.prop.refDef.name, itemId, itemProps).then((response) => {
        console.log('received response on save ', response)
        this.saveResult = response.data
      }).catch((error) => {
        if (error.response) {
          console.log('received error with response on save  ', error.response)
          this.saveResult = error.response.data
          return error.response.data
        } else {
          console.log('received error without response on save')
          this.saveResult = {success: false, message: error.message, modified: false}
          return this.saveResult
        }
      }).then(() => {
        if (callback) {
          callback(this.saveResult)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editor/RefInput.vue